import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
const IMAGES = {
  packshot: 'https://cdn.magicpatterns.com/uploads/ckEK2fDVMho2aEzwy1jUxB/imgi_30_1746975295-SnoreStop™_(1).png'
};
export function GuaranteeSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-blue-900 text-white overflow-hidden" data-id="element-149">
      <Container data-id="element-150">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-151">
          {/* Left Visual */}
          <div className="order-2 lg:order-1 relative flex justify-center" data-id="element-152">
            <div className="absolute inset-0 bg-blue-500 rounded-full filter blur-3xl opacity-20" data-id="element-153"></div>
            <div className="relative z-10" data-id="element-154">
              <img src={IMAGES.packshot} alt="SnoreStop Guarantee" className="w-64 md:w-80 drop-shadow-2xl" data-id="element-155" />
              <div className="absolute top-0 -right-4 bg-white text-blue-900 rounded-full p-4 shadow-xl border-4 border-blue-200" data-id="element-156">
                <ShieldCheck className="w-12 h-12" data-id="element-157" />
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="order-1 lg:order-2 text-center lg:text-left" data-id="element-158">
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-159">
              90-Day Money-Back Guarantee
            </h2>
            <p className="text-xl text-blue-100 mb-8 leading-relaxed" data-id="element-160">
              Try SnoreStop™ risk-free for 90 nights. If your snoring doesn't
              improve and your partner isn't sleeping better… We refund every
              penny. No forms. No stress. No BS.
            </p>
            <Button onClick={scrollToPricing} variant="secondary" size="lg" className="shadow-xl shadow-blue-950/50" data-id="element-161">
              Try SnoreStop™ Risk-Free →
            </Button>
            <p className="mt-4 text-sm text-blue-300 opacity-80" data-id="element-162">
              Join thousands of happy couples today.
            </p>
          </div>
        </div>
      </Container>
    </section>;
}